/* src/app/admin-dashboard/regulering/regulering-popup/regulering-popup.component.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 20px;
  padding: 30px;
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
  margin-bottom: 10px !important;
}
::ng-deep app-stock-filler-data-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
::ng-deep .mat-mdc-dialog-actions {
  margin-right: 5px !important;
  margin-left: 0 !important;
  margin-bottom: 2px !important;
}
@media (min-width:629px) {
  .form-control::-webkit-input-placeholder {
    color: transparent;
  }
  .form-control:-moz-placeholder {
    color: transparent;
  }
  .form-control::-moz-placeholder {
    color: transparent;
  }
  .form-control :-ms-input-placeholder {
    color: transparent;
  }
}
@media (max-width:629px) {
  div.optionalstuff {
    display: none;
  }
}
/*# sourceMappingURL=regulering-popup.component.css.map */
